import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../components/Converter";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import Dash from "../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";

function BondConditions({ value, showModal }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("aeussre.bondConditions")}</p>}
      indicesValue={
        <span>
          &eta;<sub>2</sub>
        </span>
      }
      formulaValue={
        <>
          <span onClick={() => showModal(true)}>
            <PlusIcon />
          </span>

          <ToolTip
            id={"BondConditions"}
            type={IconType.INFO}
            text={t("aeussre.bondConditions_info")}
          />
        </>
      }
      inputValue={<span className="input">{ConvertToString(value, 2)}</span>}
      unitValue={<Dash />}
    />
  );
}

export default BondConditions;
